import React from "react";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { Button } from '../Component/CommonFormEle';

function AdminDetails({
  admin,
  editedAdmin,
  onBackClick,
  onEditAdminInputChange,
  onEditAdminSubmit,
  isSuperAdmin,
}) {
  return (
    <div className="midde_cont">
      <div className="container-fluid">
        <div className="row column_title">
          <div className="col-md-12">
            <div
              className="page_title"
              style={{ display: "flex", alignItems: "center" }}
            >
              <ArrowBackRoundedIcon
                onClick={onBackClick}
                sx={{
                  fontSize: "1rem",
                  color: "black",
                  marginRight: "10px",
                  cursor: "pointer",
                }}
              />

              <h2 style={{ flex: "1" }}>{editedAdmin.name}</h2>
            </div>
          </div>
        </div>

        <div className="full inner_elements">
          <div className="col-md-12">
            <div className="admin-details">
              <div className="col-md-7 col-lg-8">
                <form
                  className="needs-validation"
                  noValidate
                  style={{ margin: "100px 0px 0px 0px" }}
                >
                  <div className="row g-3">
                    <div className="col-12">
                      <label htmlFor="username" className="form-label">
                        Admin Name
                      </label>
                      <div className="input-group has-validation">
                        <span className="input-group-text">@</span>
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          value={editedAdmin.name}
                          onChange={onEditAdminInputChange}
                          readOnly={!isSuperAdmin}
                        />
                        <div className="invalid-feedback">
                          Your Admin Name is required.
                        </div>
                      </div>
                    </div>
                    <div className="col-12" style={{ marginTop: "1em" }}>
                      <label htmlFor="email" className="form-label">
                        Email
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        placeholder="you@example.com"
                        name="email"
                        value={editedAdmin.email}
                        onChange={onEditAdminInputChange}
                        readOnly
                      />
                      <div className="invalid-feedback">
                        Please enter a valid email address.
                      </div>
                    </div>
                  </div>
                  {isSuperAdmin && (
                    <div className="form-check" style={{ marginTop: "1em" }}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="isSuperAdmin"
                        checked={editedAdmin.isSuperAdmin}
                        onChange={onEditAdminInputChange}
                        id="isSuperAdmin"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isSuperAdmin"
                      >
                        Can create admins
                      </label>
                    </div>
                  )}
                  <hr className="my-4" />
                                  {isSuperAdmin && (
                        <Button onClick={onEditAdminSubmit}>
                                        Save
                                    </Button>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminDetails;